var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    [
      _c("action-header", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("ComponentTree.filter.tooltip"),
                expression: "$t('ComponentTree.filter.tooltip')"
              }
            ],
            staticClass: "search"
          },
          [
            _c("VueIcon", { attrs: { icon: "search" } }),
            _c("input", {
              ref: "filterInstances",
              attrs: { placeholder: "Filter components" },
              on: { input: _vm.filterInstances }
            })
          ],
          1
        ),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("ComponentTree.select.tooltip"),
                expression: "$t('ComponentTree.select.tooltip')"
              }
            ],
            staticClass: "button select-component",
            class: { active: _vm.selecting },
            on: {
              click: function($event) {
                return _vm.setSelecting(!_vm.selecting)
              }
            }
          },
          [
            _c("VueIcon", {
              attrs: { icon: _vm.selecting ? "gps_fixed" : "gps_not_fixed" }
            }),
            _c("span", [_vm._v("Select")])
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "tree",
          class: {
            "high-density": _vm.finalHighDensity
          },
          attrs: { slot: "scroll" },
          slot: "scroll"
        },
        _vm._l(_vm.instances, function(instance) {
          return _c("component-instance", {
            key: instance.id,
            ref: "instances",
            refInFor: true,
            attrs: { instance: instance, depth: 0 }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }